<template>
	<div class="background-wrapper d-flex px-3">
		<page class="page d-flex justify-center">
			<v-row
				class="mt-3"
				align="start"
				justify="center"
			>
				<v-col cols="8">
					<close-app-logo color="dark" />
				</v-col>
			</v-row>
			<v-row
				align="start"
				justify="center"
			>
				<v-col>
					<h2>התשלום התקבל בהצלחה!</h2>
					<h3 class="text-center white--text">
						בדקות הקרובות יתקבל מייל עם אישור הרכישה
					</h3>
				</v-col>
			</v-row>
			<v-row v-if="!autoRedirect">
				<v-col
					class="d-flex justify-center"
				>
					<v-btn
						color="success"
						class="mt-3"
						:href="redirectLink"
					>
						למעבר לפרויקט
					</v-btn>
					<v-btn
						color="primary"
						class="mt-3"
						:to="{name:'purchase-history'}"
					>
						להסטורית תשלומים
					</v-btn>
				</v-col>
			</v-row>
			<div v-else>
				<v-row>
					<v-col
						class="d-flex justify-center"
					>
						<h2 class="text-center">
							מיד תועברו לעמוד המבוקש
						</h2>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-progress-linear
							v-model="progressVal"
							height="10"
							color="white"
						/>
					</v-col>
				</v-row>
			</div>
		</page>
		<div
			class="background-image"
		/>
	</div>
</template>

<script>
import CloseAppLogo from "@/components/CloseAppLogo";
import { types } from "@/store/modules/Project.module";

export default {
	name: "ThankYouPage",
	components: { CloseAppLogo },
	data () {
		return {
			autoRedirect: "",
			progressVal: 0,
		};
	},
	computed: {
		redirectLink () {
			const token = this.$route.query.token;
			const params = JSON.parse(window.localStorage.getItem("queryString"));
			let queryString = "";
			Object.entries(params).forEach(([key, value]) => {
				queryString += "&" + key + "=" + value;
			});
			return "/api/redirectToProject?token=" + token + queryString;
		},
	},
	watch: {
		value () {
			return 10;
		},
	},
	async created () {
		const project = sessionStorage.getItem("activeProject");
		await this.$store.dispatch(types.GET, project).then((response) => {
			if (response.show_redirect) {
				this.autoRedirect = false;
			} else {
				this.autoRedirect = true;
				this.startRedirect();
			}
		});
	},
	methods: {
		startBuffer () {
			setInterval(() => {
				this.progressVal += 1;
			}, 1);
		},
		startRedirect () {
			const TIME_OUT = 5000;
			this.startBuffer();
			setTimeout(() => {
				window.location = this.redirectLink;
			}, TIME_OUT);
		},
	},
};
</script>

<style lang="scss" scoped>
@import "./../../sass/generic";

.background-wrapper {
	background-color: #905496;
	height: 100%;
}

.background-image {
	z-index: -1 !important;
	position: fixed;
	height: 100%;
	width: 100%;
	left: 0;
	top: 0;
	webkit-background-size: cover !important;
	-moz-background-size: cover !important;
	-o-background-size: cover !important;
	background-size: cover !important;
	background-position: center !important;
	background-repeat: no-repeat !important;
	filter: blur(6px);
	-webkit-filter: blur(6px);
	transform: scale(1.03)
}

.page {
	width: 90%;
	margin: auto;
	max-height: 55% !important;
	background-color: $background;
	border-radius: 25px;

	@include responsive($mobile) {
		max-width: $mobile !important;
		max-height: $mobile-height;
	}
}
</style>
